let phoneRegular = /^1(3|4|5|6|7|8|9)\d{9}$/

export default {
  PHONEREGULAR: phoneRegular
}
